import Collection from "../../data-structures/collection"
import ModelEntity from "../model-entity"
import Relation from "./relation"
import relationsFromJson from "./helpers/relations-from-json"
import {BUS_RELATIONS_CHANGED} from "./const"

// The relations of ONE item. It holds the item being viewed, which is what every
// Relation in it resolved its `relatedItem` against.
export default class RelationsCollection extends Collection<Relation> {

    public currentItem: ModelEntity

    constructor(currentItem: ModelEntity) {
        super([])

        this.currentItem = currentItem

        // Assigned AFTER construction, so building the collection is silent:
        // every host renders explicitly once its item has loaded.
        this.onChangeBusEvent = BUS_RELATIONS_CHANGED(currentItem.itemType, currentItem.id)
    }


    // --- change event

    // For a host that already holds the collection; one that subscribes before
    // its item has loaded builds the same name from BUS_RELATIONS_CHANGED.
    get changeEvent(): string {
        return this.onChangeBusEvent!
    }

    // Debounced, unlike the base class: a change often arrives as several
    // mutations in a row.
    triggerBusEvent() {
        if (!this.onChangeBusEvent) return

        gd.bus.triggerEventDebounced(this.onChangeBusEvent)
    }


    // --- rows

    // Every drop rule is `canShow`, so nothing downstream filters.
    addRelation(relation: Relation) {
        if (relation.canShow) this.add(relation)
    }

    // Add, or replace a row already held under the same link id (an optimistic
    // add followed by the live event for the same link).
    upsert(relation: Relation) {
        if (!relation.canShow) return

        if (this.get(relation.id))  this.replace(relation.id, relation)
        else                        this.add(relation)
    }


    // --- build

    static initFromJson(relatedItems: any, currentItem: ModelEntity): RelationsCollection {

        const collection = new RelationsCollection(currentItem)

        _.each(relationsFromJson(relatedItems, currentItem), (relation: Relation) => {
            collection.addRelation(relation)
        })

        return collection
    }
}
